import React from "react";

const TextWithBreaks = ({ text }: { text: string }) => (
    <>
      {text.split('\n').map((line, i) => (
        <React.Fragment key={i}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </>
  );
  
export default TextWithBreaks;